"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmptyCartState = /** @class */ (function () {
    function EmptyCartState() {
        this.displayLinkCopiedText = false;
        this.showEmptyCartModal = false;
    }
    return EmptyCartState;
}());
exports.default = EmptyCartState;
//# sourceMappingURL=EmptyCartState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/EmptyCart/EmptyCartState.js
// module id = 2341
// module chunks = 8